import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import { ConfigurationFile } from 'containers/misc'
import { Table, Data } from 'components/layout/Table'
import { meta, permissions } from 'helpers/decorators'
import { CONFIGURATION_KEYS, POLICIES_TYPES } from 'constants/enums'
import { connect } from 'react-redux'
import { setActiveOrganization } from '../../../redux/modules/auth'
import { apiConfiguration } from '../../../helpers/decorators/api'
import { get, toNumber } from 'lodash'
import styles from './user-guide.styl'
import ShowPolicyModal from '../../../components/modals/policies/ShowPolicyModal'
import { modal } from 'redux/modules/app'


const tableHeaders = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.name'
  },
  {
    id: 2,
    label: 'Actions',
    intlKey: 'table.actions'
  }
]

const enhance = compose(
    connect(
        ({ auth, api }) => ({
          user: auth.user,
          organization: auth.organization,
          configuration: api.configuration,
        }),
        { setActiveOrganization, modal }
    ),
    apiConfiguration({
      getValues: [
        CONFIGURATION_KEYS.privacyPolicyText.id,
        CONFIGURATION_KEYS.auCoConductDoc.id,
        CONFIGURATION_KEYS.naoRegRequirementsUrl.id,
        CONFIGURATION_KEYS.termsAndConditions.id,
        CONFIGURATION_KEYS.AwardLeaderRegistrationPrivacyPolicyUrl.id
      ]
    }),
    meta({
      title: 'Guides and Policies',
      intlKey: 'pageTitle.guides_and_policies'
    }),
    permissions()
)

class UserGuide extends Component {
  static propTypes = {
    permissions: PropTypes.object.isRequired,
    configuration: PropTypes.object,
    onGetConfigurationValue: PropTypes.func,
    modal: PropTypes.func
  }

  state = {
    policyName: '',
    policyContent: ''
  }

  setPolicyContent = (policyName, policyContent) => {
    this.setState({ policyContent, policyName })
    this.props.modal('show-policy-content-modal')
  }

  getValueByType = policy => {
    switch(get(policy, 'type')){

      case POLICIES_TYPES.link.id:
        return (<a href={`${get(policy, 'value')}`}>
                  <FormattedMessage
                    id="button.visit"
                    defaultMessage="Visit"
                />
              </a>)

      case POLICIES_TYPES.file.id:
        return (<ConfigurationFile
            configKey={get(policy, 'code')}
            isPublic
            inline
            formattedName={
              <FormattedMessage
                  id="button.download"
                  defaultMessage="Download"
              />
            }
        />)

      case POLICIES_TYPES.text.id:
        const policyName = get(policy, 'name')

        const policyContent = get(policy, 'value')

        return (<a className={styles.show} onClick={() => this.setPolicyContent(policyName, policyContent)}>
              <FormattedMessage id="button.show" defaultMessage="Show" />
              </a>)

      default: break
    }
  }

  render() {
    const { permissions: userPermissions, configuration, params, activeOrganization, modal } = this.props

    const orgId = toNumber(params.id || activeOrganization.id)

    const privacyPolicyUrl = get(configuration,`valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.AwardLeaderRegistrationPrivacyPolicyUrl.id}]`)

    const auCoConductDoc = get(configuration,`valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.auCoConductDoc.id}]`)

    const naoRegRequirementsUrl = get(configuration,`valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.naoRegRequirementsUrl.id}]`)

    const termsAndConditions = get(configuration,`valuesByOrganizationId[${orgId}][${CONFIGURATION_KEYS.termsAndConditions.id}]`)

    let policies = []

/*    policies.push({
      code: CONFIGURATION_KEYS.privacyPolicyText.id,
      name:<FormattedMessage id="label.privacy_notice" defaultMessage="Privacy Notice" />,
      value: get(privacyPolicyText, 'translatedText'),
      type: POLICIES_TYPES.text.id
        })*/

    policies.push({
      code: CONFIGURATION_KEYS.AwardLeaderRegistrationPrivacyPolicyUrl.id,
      name:<FormattedMessage id="label.privacy_notice" defaultMessage="Privacy Notice" />,
      value: get(privacyPolicyUrl, 'textValue'),
      type: POLICIES_TYPES.link.id
    })

    policies.push({
      code: CONFIGURATION_KEYS.auCoConductDoc.id,
      name:<FormattedMessage id="label.code_of_conduct" defaultMessage="Code of Conduct" />,
      value: get(auCoConductDoc, 'fileUrl'),
      type: POLICIES_TYPES.file.id
    })

    policies.push({
      code: CONFIGURATION_KEYS.naoRegRequirementsUrl.id,
      name:<FormattedMessage id="label.nao_regulations" defaultMessage="NAO Regulations" />,
      value: get(naoRegRequirementsUrl, 'textValue'),
      type: POLICIES_TYPES.link.id
    })

    policies.push({
      code: CONFIGURATION_KEYS.termsAndConditions.id,
      name:<FormattedMessage id="label.terms_and_conditions" defaultMessage="Terms and Conditions" />,
      value: get(termsAndConditions, 'fileUrl'),
      type: POLICIES_TYPES.file.id
    })

    return (
      <div className={styles.tablesWrapper}>

        <h2 className="text--left">
          <FormattedMessage
              id="moduleTitle.guides"
              defaultMessage="Guides"
          />
        </h2>
      <Table ths={tableHeaders}>
        <Data>
          <tr>
            <td>
              <FormattedMessage
                id="label.user_app_guide_leader"
                defaultMessage="User app guide - Award Leader"
              />
            </td>
            <td>
              <ConfigurationFile
                configKey={CONFIGURATION_KEYS.userGuideLeader.id}
                isPublic
                inline
                formattedName={
                  <FormattedMessage
                    id="button.download"
                    defaultMessage="Download"
                  />
                }
              />
            </td>
          </tr>
          <tr>
            <td>
              <FormattedMessage
                id="label.user_guide_web_leader"
                defaultMessage="User web guide - Award Leader"
              />
            </td>
            <td>
              <ConfigurationFile
                configKey={CONFIGURATION_KEYS.userGuideWebLeader.id}
                isPublic
                inline
                formattedName={
                  <FormattedMessage
                    id="button.download"
                    defaultMessage="Download"
                  />
                }
              />
            </td>
          </tr>
          <tr>
            <td>
              <FormattedMessage
                id="label.user_guide_web_participant"
                defaultMessage="User web guide - Participant"
              />
            </td>
            <td>
              <ConfigurationFile
                configKey={CONFIGURATION_KEYS.userGuideWebParticipant.id}
                isPublic
                inline
                formattedName={
                  <FormattedMessage
                    id="button.download"
                    defaultMessage="Download"
                  />
                }
              />
            </td>
          </tr>
          <tr>
            <td>
              <FormattedMessage
                id="label.user_app_guide_participant"
                defaultMessage="User app guide - Participant"
              />
            </td>
            <td>
              <ConfigurationFile
                configKey={CONFIGURATION_KEYS.userGuideParticipant.id}
                isPublic
                inline
                formattedName={
                  <FormattedMessage
                    id="button.download"
                    defaultMessage="Download"
                  />
                }
              />
            </td>
          </tr>
          {userPermissions.isNaoStaff &&
            <tr>
              <td>
                <FormattedMessage
                  id="label.user_guide_web_nao"
                  defaultMessage="User web guide - NAO"
                />
              </td>
              <td>
                <ConfigurationFile
                  configKey={CONFIGURATION_KEYS.userGuideWebNao.id}
                  isPublic
                  inline
                  formattedName={
                    <FormattedMessage
                      id="button.download"
                      defaultMessage="Download"
                    />
                  }
                />
              </td>
            </tr>}


{/*          <tr>
            <td>
              <FormattedMessage
                id="label.frequently_asked_questions"
                defaultMessage="Frequently asked questions"
              />
            </td>
            <td>
              <ConfigurationFile
                configKey={CONFIGURATION_KEYS.faqDocuments.id}
                isPublic
                inline
                formattedName={
                  <FormattedMessage
                    id="button.download"
                    defaultMessage="Download"
                  />
                }
              />
            </td>
          </tr>*/}
        </Data>
      </Table>

        <h2 className="text--left">
          <FormattedMessage
              id="moduleTitle.policies"
              defaultMessage="Policies"
          />
        </h2>
    <div className={styles.policies}>
        <Table  ths={tableHeaders}>
      <Data>
        {policies.map((item) => (
        <tr>
          <td>
            {get(item, 'name')}
          </td>
          <td>
            { this.getValueByType(item) }
          </td>
        </tr>
        ))}
        <tr>
          <td>
            <FormattedMessage
                id="label.safeguarding_policy"
                defaultMessage="Safeguarding Policy/Code of Conduct"
            />
          </td><td><a href='https://intaward.org/wp-content/uploads/2020/09/Safeguarding-Policy-2020-Final.pdf'>
          <FormattedMessage
              id="button.visit"
              defaultMessage="Visit"
          />
        </a></td></tr>
      </Data>
    </Table>
    </div>

     <ShowPolicyModal
         modalId='show-policy-content-modal'
         modal={modal}
         policyContent={this.state.policyContent}
         policyName={this.state.policyName}
     />
    </div>
    )
  }
}

export default enhance(UserGuide)
